export default {
  name: 'emergencyDrillSignature',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest(`/crewconfig/meeting/drill/${data.drillid}`, 'POST', data)
  },
  restoreSave: (ctx) => {
  }
}
